import Controller, { OnClick } from '@philips-internal/oswald-ui-core/lib/client';
import { SubmitEvent } from '@philips-internal/oswald-ui-core/lib/component/types';
import { Value } from '@philips-internal/oswald-ui-core';
import { HttpService } from '@philips-internal/oswald-ui-core/lib/services';
import { APPLICATION_ENDPOINTS } from '../../constants/application-endpoints';
import UserContext from '../../utils/user-context';
import BaseController from '../BaseController';
import { Inject } from '@odinjs/odin';
import { FragmentNames, MyChartPastHistoryInactivateAliases } from '../../codegen';
import { ContextType, SubmittableFragmentContext } from '@philips-internal/oswald-ui-core/lib/component/context';
import { InputAPI } from '@philips-internal/oswald-ui-components';

@Controller({ fragment: FragmentNames.MY_CHART_PAST_HISTORY_INACTIVATE })
class MyChartPastHistoryInactivateController extends BaseController {

  @Inject(ContextType.SUBMITTABLE_FRAGMENT)
    submittableFragmentContext!: SubmittableFragmentContext;

  @Inject(MyChartPastHistoryInactivateAliases.INPUT_REASON_INACTIVATE)
    inactivateFieldNotes!: InputAPI;

  @OnClick({ target: MyChartPastHistoryInactivateAliases.BUTTON_MODAL_CANCEL })
  handleBtnCancel(): void {
    this.submittableFragmentContext.cancel(new SubmitEvent());
  }

  @OnClick({ target: MyChartPastHistoryInactivateAliases.BUTTON_MODAL_INACTIVATE })
  handleBtnSendNewPastHistory(): void {
    const pastHistorySequence = this.historyService.getCurrentRouteParams().pastHistorySequence as string;
    const justification = this.inactivateFieldNotes.getValue();

    const body = {
      id: pastHistorySequence,
      justification: justification.toString()
    } as Record<string, Value>;

    this.context.set({
      params: {
        ...body
      }
    });
    HttpService.post(APPLICATION_ENDPOINTS.POST_MC_PAST_HISTORY_INACTIVATE, {  patientId: UserContext.patientId }, { body })
      .then(() => {
        this.submittableFragmentContext.submit(new SubmitEvent());
      });
  }
}
export default MyChartPastHistoryInactivateController;